import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import CategoryClip from "layouts/products/AddProduct/ProductForm/CategoryClip";
import { subCategoryApi } from "store/api";

export default function AddBrand ({
  open,
  category,
  handleClose,
  handleSubmit,
  addCategoryData,
  addCategoryImage,
  handleChangeAddCategory,
  handleChangeAddCategoryImage,
}) {
  const [selectedCategory, setSelectedCategory] = React.useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = React.useState([]);

  const fetchSubCategories = async categoryId => {
    const response = await subCategoryApi({ categoryId: categoryId });
    if (response?.success) {
      return response?.data;
    }
    return [];
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Add Brand"}</DialogTitle>
        <form onSubmit={e => handleSubmit(e, selectedSubCategories)}>
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>Name</label>
                <input
                  value={addCategoryData?.name}
                  onChange={handleChangeAddCategory}
                  name='name'
                  type='text'
                  required
                  placeholder='Enter Brand name'
                  style={{
                    padding: "10px",
                    border: "2px solid #c4c4c4",
                    borderRadius: "6px",
                    color: "gray",
                    width: "260px",
                  }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>Brand Image</label>
                {addCategoryImage?.image && (
                  <div style={styles.previewContainer}>
                    <div style={styles.imageWrapper}>
                      <img
                        src={URL.createObjectURL(addCategoryImage?.image)}
                        alt={`preview`}
                        style={styles.image}
                      />
                    </div>
                  </div>
                )}
                <input
                  value={handleChangeAddCategoryImage?.image}
                  onChange={handleChangeAddCategoryImage}
                  name='image'
                  type='file'
                  required
                  accept='image/*'
                  style={{
                    padding: "10px",
                    border: "2px solid #c4c4c4",
                    borderRadius: "6px",
                    color: "gray",
                    width: "260px",
                  }}
                />
              </div>
              <div style={{ paddingTop: "10px" }}>
                <lable>Visible</lable>
                <RadioGroup
                  style={{ width: "100%" }}
                  row
                  aria-labelledby='demo-row-radio-buttons-group-label'
                  name='isActive'
                  required
                  onChange={handleChangeAddCategory}
                  value={addCategoryData?.isActive}
                >
                  <FormControlLabel
                    style={{ fontSize: "12px" }}
                    value={true}
                    control={<Radio size='small' />}
                    label='Yes'
                    defaultChecked={false}
                  />
                  <FormControlLabel
                    style={{ fontSize: "12px" }}
                    value={false}
                    control={<Radio size='small' />}
                    defaultChecked={false}
                    label='Not Yet'
                  />
                </RadioGroup>
              </div>
              {/* <CategoryClip
                categories={category}
                setSelectedCategories={setSelectedCategory}
                fetchSubCategories={fetchSubCategories}
                selectedCategories={selectedCategory}
                selectedSubCategories={selectedSubCategories}
                setSelectedSubCategories={setSelectedSubCategories}
              /> */}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' autoFocus>
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    // marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "120px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
